import BusinessIcon from '@mui/icons-material/Business';

export const CompanyIcon = BusinessIcon;
